import { ExternalLink, KeyRound } from "lucide-react";
import { DASHBOARD } from "@/lib/jammableApi";

/** Shown until the Jammable key is added — what it is, where to get it, what it costs. */
export default function KeyMissing() {
  return (
    <div data-testid="jam-key-missing" className="rounded-2xl border border-amber-300/30 bg-amber-500/[0.08] p-4 text-[13px] leading-relaxed text-amber-50/90">
      <p className="flex items-center gap-2 font-display text-[15px] font-semibold text-amber-100"><KeyRound className="h-4 w-4" /> Add your Jammable key to switch this on</p>
      <ol className="mt-2 list-decimal space-y-1 pl-5 text-white/75">
        <li>Sign in at Jammable and open the Developer Dashboard.</li>
        <li>Create a key (it starts with <span className="font-mono">jmb_live_</span>) and add at least $10 of balance.</li>
        <li>Send the key to your builder through the secure key box — never paste it in chat.</li>
      </ol>
      <p className="mt-2 text-white/55">Voice changes cost about $0.25 per minute of audio (failed jobs are free).</p>
      <a href={DASHBOARD} target="_blank" rel="noreferrer" data-testid="jam-dashboard-link" className="mt-3 inline-flex items-center gap-1.5 font-mono text-[11px] uppercase tracking-wider text-amber-200 hover:text-white">
        Open the Jammable dashboard <ExternalLink className="h-3.5 w-3.5" />
      </a>
    </div>
  );
}
